import { render, staticRenderFns } from "./DevDocsList.vue?vue&type=template&id=bb560db4&scoped=true&"
import script from "./DevDocsList.vue?vue&type=script&lang=js&"
export * from "./DevDocsList.vue?vue&type=script&lang=js&"
import style0 from "./DevDocsList.vue?vue&type=style&index=0&id=bb560db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb560db4",
  null
  
)

export default component.exports